module.exports = __webpack_public_path__ + "img/valentine-dark-small.57b45541.svg";